// Elements
export const faAnemo = {
	prefix: 'faga',
	iconName: "anemo",
	icon: [
		14, 13.857,
		[],
		null,
		"M.2,4.834c.764,1.2,1.813,2.475,3.362,2.434,1.025-.067,2.374.224,2.679,1.359.313.865-.825,1.982-1.513,1.124-.108-.187-.039-.3.173-.326,1,.021,1.348-1.12.4-1.513-.813-.1-1.548.527-2.329.707C.791,9.247-.524,6.656.2,4.834Zm9.912,2.429c-1.056-.074-2.449.563-2.375,1.786a.973.973,0,0,0,1.1.984c.316.013.724-.546.294-.612-1.621,0-1.022-2.1.346-1.4a5.222,5.222,0,0,0,2.343.687c1.8-.177,2.572-2.3,1.989-3.859C12.938,6.152,11.852,7.446,10.112,7.263Zm-2.42-.772A7.516,7.516,0,0,0,9.918,5.63,3.067,3.067,0,0,0,9.286.018,5.143,5.143,0,0,1,7.692,6.491ZM6.349,6.477A5.071,5.071,0,0,1,4.734,0,3.075,3.075,0,0,0,3.612,5.287a7.944,7.944,0,0,0,2.7,1.235Zm5.342-.089c-1.143.656-2.594.363-3.651,1.217a1.557,1.557,0,0,0,.07,2.768c.234.1.462.206.689.014.223-.167.4-.162.721-.012a9.094,9.094,0,0,0-2.513,3.482,9.217,9.217,0,0,0-2.523-3.478.605.605,0,0,1,.726,0c.6.347,1.443-.4,1.555-1C7.012,8.2,5.829,7.273,4.783,7.049c-.512-.121-1.038-.182-1.55-.3C.866,6.266.51,3.868,1.669,2.034c.668,4.9,4,3.555,5.332,6.26,1.321-2.671,4.678-1.382,5.345-6.261C13.157,3.449,13.4,5.556,11.691,6.388Zm-4.12,5.191L7,11.2l-.572.385.58.972ZM7,10.066a1.592,1.592,0,0,1-1,.911.925.925,0,0,0,.991-.272c.426.327.794.417,1.046.255A1.561,1.561,0,0,1,7,10.066Z"
	]
} as const

export const faCryo = {
	prefix: 'faga',
	iconName: "cryo",
	icon: [
		12.086, 14,
		[],
		null,
		"M0,3.52A19.776,19.776,0,0,1,1.911,6.8a6.152,6.152,0,0,0,.128-.624A6.476,6.476,0,0,1,5.5,6.7,6.479,6.479,0,0,1,3.316,3.96a6.308,6.308,0,0,0,.477-.423A19.8,19.8,0,0,1,0,3.52ZM4.411,6.067a7.469,7.469,0,0,0-2.4-.573,3.548,3.548,0,0,0-.2-.933h0a3.559,3.559,0,0,0,.909-.289A7.478,7.478,0,0,0,4.411,6.067ZM0,10.48A19.776,19.776,0,0,0,1.911,7.2a6.152,6.152,0,0,1,.128.624A6.476,6.476,0,0,0,5.5,7.3,6.479,6.479,0,0,0,3.316,10.04a6.308,6.308,0,0,1,.477.423A19.8,19.8,0,0,0,0,10.48ZM4.411,7.933a7.469,7.469,0,0,1-2.4.573,3.548,3.548,0,0,1-.2.933h0a3.559,3.559,0,0,1,.909.289A7.478,7.478,0,0,1,4.411,7.933ZM6.043,14a19.768,19.768,0,0,0-1.882-3.293,6.161,6.161,0,0,1,.605.2A6.467,6.467,0,0,0,6.043,7.649,6.478,6.478,0,0,0,7.32,10.908a6.251,6.251,0,0,1,.6-.2A19.768,19.768,0,0,0,6.043,14Zm0-5.094a7.461,7.461,0,0,1-.7,2.368,3.577,3.577,0,0,1,.705.643h0a3.561,3.561,0,0,1,.706-.643A7.48,7.48,0,0,1,6.043,8.906Zm6.043,1.574A19.85,19.85,0,0,1,10.175,7.2a6.215,6.215,0,0,0-.127.624A6.479,6.479,0,0,1,6.586,7.3,6.486,6.486,0,0,1,8.771,10.04a6.112,6.112,0,0,0-.477.423A19.783,19.783,0,0,1,12.086,10.48ZM7.675,7.933a7.473,7.473,0,0,0,2.4.573,3.548,3.548,0,0,0,.2.933h0a3.562,3.562,0,0,0-.91.289A7.478,7.478,0,0,0,7.675,7.933ZM12.086,3.52A19.85,19.85,0,0,0,10.175,6.8a6.215,6.215,0,0,1-.127-.624A6.479,6.479,0,0,0,6.586,6.7,6.486,6.486,0,0,0,8.771,3.96a6.112,6.112,0,0,1-.477-.423A19.783,19.783,0,0,0,12.086,3.52ZM7.675,6.067a7.473,7.473,0,0,1,2.4-.573,3.548,3.548,0,0,1,.2-.933h0a3.562,3.562,0,0,1-.91-.289A7.478,7.478,0,0,1,7.675,6.067ZM6.043,0A19.768,19.768,0,0,1,4.161,3.293a6.161,6.161,0,0,0,.605-.2A6.467,6.467,0,0,1,6.043,6.351,6.478,6.478,0,0,1,7.32,3.092a6.251,6.251,0,0,0,.6.2A19.768,19.768,0,0,1,6.043,0Zm0,5.094a7.461,7.461,0,0,0-.7-2.368,3.577,3.577,0,0,0,.705-.643h0a3.561,3.561,0,0,0,.706.643A7.48,7.48,0,0,0,6.043,5.094Zm.1,2.038,1.044.92-.071.817-.744-.347L6.1,7.157a.163.163,0,0,1-.115,0L5.711,8.522l-.743.347L4.9,8.052l1.044-.92a.165.165,0,0,1-.062-.1l-1.314.443-.672-.471.672-.47,1.312.442a.17.17,0,0,1,.056-.1L4.9,5.961l.071-.817.743.347.272,1.352a.166.166,0,0,1,.12,0l.272-1.352.744-.347.071.817-1.037.913a.165.165,0,0,1,.056.1l1.313-.442.672.47-.672.471L6.208,7.034A.165.165,0,0,1,6.146,7.132Z"
	]
} as const

export const faDendro = {
	prefix: 'faga',
	iconName: "dengro",
	icon: [
		14, 13.314,
		[],
		null,
		"M10.956,7.949c-1.242-.339-2.145.509-3.174,1.065.5-.835,1.613-1.371,1.588-2.466A1.122,1.122,0,0,0,8.041,5.379c.741-1.764,3.98.034,2.174,1.958C10.518,7.478,10.839,7.589,10.956,7.949Zm-7.919,0c1.242-.339,2.144.509,3.173,1.065-.5-.835-1.613-1.371-1.587-2.466A1.121,1.121,0,0,1,5.952,5.379c-.742-1.764-3.98.034-2.174,1.958C3.474,7.478,3.153,7.589,3.037,7.949ZM7,11.38C6.11,9.815,4.008,9.887,2.989,8.436.769,5.889,4.028,2.245,6.5,4.573c.88-1.994-3.2-1.85-4.069-.59-.1-.709-.187-1.217-.962-1.305C1.3,2.692.355,2.473.452,2.737c.37,1.113.5,1.67,1.824,1.4a4.167,4.167,0,0,0-.731,3.139C.825,6.681.636,6.927,0,7.46c1.239,1.223,1.412-.3,1.632.133C2.207,10.851,5.976,10.376,7,13.314c1.023-2.936,4.794-2.465,5.368-5.721.22-.429.393,1.09,1.632-.133-.636-.533-.825-.779-1.545-.186a4.167,4.167,0,0,0-.731-3.139c1.328.272,1.454-.285,1.824-1.4.1-.264-.852-.045-1.015-.059-.775.088-.859.6-.962,1.3-.864-1.26-4.95-1.4-4.07.591C9.969,2.245,13.235,5.89,11.01,8.437,9.992,9.887,7.89,9.815,7,11.38M7.007,0C5.986,1.347,5.175,2.309,6.993,3.6,8.792,2.311,8.083,1.485,7.007,0Z"
	]
} as const

export const faElectro = {
	prefix: 'faga',
	iconName: "electro",
	icon: [
		14, 13.996,
		[],
		null,
		"M4.533,13.505a6.911,6.911,0,0,0,3.024-.468c-.237-.073-.459-.134-.675-.209s-.432-.159-.643-.252A3.907,3.907,0,0,1,4,10.333a3.449,3.449,0,0,1-.128-1.82c.117.139.222.277.341.4a1.044,1.044,0,0,0,1.01.32A1.571,1.571,0,0,0,6.5,7.879a2.422,2.422,0,0,0-2.083-2.8A2.993,2.993,0,0,0,1.2,7.231,7.083,7.083,0,0,0,.874,9.417c-.005.309,0,.618,0,.9A7.089,7.089,0,0,1,.012,6.581,6.949,6.949,0,0,1,2.691,1.5c-.26.472-.519.917-.752,1.374a3.664,3.664,0,0,0-.412,1.521c.207-.193.385-.361.566-.524A4.657,4.657,0,0,1,4.248,2.71,3.573,3.573,0,0,1,7.323,3.5l-.442.09A1.213,1.213,0,0,0,6,5.283,2.008,2.008,0,0,0,7.719,6.624a2.575,2.575,0,0,0,2.873-2.561,3.33,3.33,0,0,0-1.1-2.508A7.781,7.781,0,0,0,7.289.09C7.237.066,7.185.039,7.108,0A7,7,0,0,1,14,5.915c-.282-.45-.544-.9-.836-1.328A3.743,3.743,0,0,0,12.055,3.5c.079.371.171.721.226,1.077a4.086,4.086,0,0,1-.792,3.364A3.554,3.554,0,0,1,9.98,8.958a.115.115,0,0,1-.049,0c.062-.2.134-.389.184-.587A1.091,1.091,0,0,0,9.59,7.135a1.68,1.68,0,0,0-1.765-.046A2.357,2.357,0,0,0,6.657,10.05a2.745,2.745,0,0,0,2.377,1.878,4.373,4.373,0,0,0,2.462-.5c.465-.215.9-.5,1.344-.759.056-.032.108-.071.18-.119A6.922,6.922,0,0,1,4.533,13.505Z"
	]
} as const

export const faGeo = {
	prefix: 'faga',
	iconName: "geo",
	icon: [
		13.029, 14,
		[],
		null,
		"M6.633,6.009c-.5.538-.953,1.041-1.42,1.537a.23.23,0,0,0-.061.286A4.5,4.5,0,0,0,6.507,9.551a.181.181,0,0,0,.164-.009c.388-.257.785-.5,1.151-.788A16.081,16.081,0,0,0,9.963,6.761c.181.366.382.7.518,1.063.2.535.356,1.088.535,1.632a.293.293,0,0,1-.061.286,12.277,12.277,0,0,1-1.768,1.985c-.839.755-1.714,1.47-2.574,2.2A1.2,1.2,0,0,1,6.505,14c-.5-.411-1.02-.817-1.519-1.243A29.249,29.249,0,0,1,2.138,9.983,16.778,16.778,0,0,1,.043,7.137a.245.245,0,0,1,0-.279A10.138,10.138,0,0,1,1.389,5.1a25.247,25.247,0,0,0,5.158,8.241,12.37,12.37,0,0,0,2.98-4.617l-.036-.03L6.558,11.157c-.04-.032-.081-.061-.117-.1A13.544,13.544,0,0,1,3.879,7.693a.249.249,0,0,1,.051-.356c.5-.442,1-.89,1.5-1.325.226-.194.473-.365.736-.566Zm.228,2.545c.263-.2.51-.372.736-.566.506-.435,1-.883,1.5-1.325a.251.251,0,0,0,.051-.356A13.523,13.523,0,0,0,6.588,2.938c-.036-.034-.077-.063-.116-.1L3.539,5.306,3.5,5.276A12.345,12.345,0,0,1,6.483.659,25.245,25.245,0,0,1,11.64,8.9a10.138,10.138,0,0,0,1.345-1.758.244.244,0,0,0,0-.279,16.724,16.724,0,0,0-2.1-2.846A29.136,29.136,0,0,0,8.043,1.243C7.545.817,7.028.411,6.524,0c-.05.033-.082.049-.108.071-.86.732-1.734,1.447-2.573,2.2A12.23,12.23,0,0,0,2.075,4.258a.293.293,0,0,0-.062.286c.179.544.334,1.1.536,1.632.136.361.336.7.517,1.063A16.2,16.2,0,0,1,5.207,5.246c.366-.285.764-.531,1.151-.788a.181.181,0,0,1,.164-.009A4.5,4.5,0,0,1,7.877,6.168a.231.231,0,0,1-.06.286c-.468.5-.926,1-1.421,1.537Z"
	]
} as const

export const faHydro = {
	prefix: 'faga',
	iconName: "hydro",
	icon: [
		14, 13.95,
		[],
		null,
		"M2.922,12.219c.108.055.181.092.253.13a7.943,7.943,0,0,0,3.891.963,3.753,3.753,0,0,0,.486-7.464,3.6,3.6,0,0,0-1.691.132.938.938,0,0,1-.716-1.732,4.3,4.3,0,0,1,1.481-.366,4.912,4.912,0,0,1,5.048,3.446,4.933,4.933,0,0,1-2.517,5.764c4.218-1.543,4.723-7.809.812-10.017a5.342,5.342,0,0,0-3.437-.829A5.506,5.506,0,0,0,2.883,4.021a6.606,6.606,0,0,0-.417.524.873.873,0,0,1-.927.337.929.929,0,0,1-.781-.638.881.881,0,0,1,.1-.684A6.158,6.158,0,0,1,2.221,1.839,7.091,7.091,0,0,1,6.135.055a6.933,6.933,0,0,1,6.848,3.359c2.683,4.1-.263,9.987-5.094,10.472a6.838,6.838,0,0,1-3.241-.343A3.994,3.994,0,0,1,2.922,12.219ZM8.438,12.1a2.044,2.044,0,0,1-2.35.064,1.5,1.5,0,0,1-.007-2.613.949.949,0,0,1,1.433.505c.77,2.06,2.637.147,1.424-1.246a2.385,2.385,0,0,0-2.17-.95,2.486,2.486,0,1,0,.784,4.891A2.393,2.393,0,0,0,9.073,11.6C8.862,11.766,8.663,11.951,8.438,12.1ZM2.21,9.495a.663.663,0,1,0,.663.663A.663.663,0,0,0,2.21,9.495ZM.958,6.107a.958.958,0,1,0,.957.957A.958.958,0,0,0,.958,6.107Z"
	]
} as const

export const faPyro = {
	prefix: 'faga',
	iconName: "pyro",
	icon: [
		11.479, 14,
		[],
		null,
		"M5.853,14C4.311,12.53,2.374,11.75.692,10.523c-1.471-1.1-.268-3.047.586-4.163A17.969,17.969,0,0,0,3.031,3.838c-.007,1.6,1.56,2.152,2.781,2.709C3.509,6.412,1.548,9.1,3.385,10.92c-1.873-.773-2.7-2.455-1.3-4.17a2.113,2.113,0,0,0-.535,3.662c1.332.9,2.865,1.483,4.153,2.461a.2.2,0,0,0,.187.019C7.13,12,8.5,11.315,9.811,10.543c1.654-.887,1.47-2.773-.154-3.583,1.455,2.82-1.213,4.942-3.9,4.745C2.832,11.491,2.676,8.531,5.131,9a1.39,1.39,0,0,0-.682,1.5c.526,1.495,2.954.974,3.81.031,1.095-1.027.327-3.031-.979-3.6-1.492-.7-4.443-1.527-3.3-3.737C4.676,2.109,5.49,1.385,5.617,0,6.05.581,7.06,1.719,6.857,2.452c-.24.72-1.085.982-1.348,1.71a1.334,1.334,0,0,0,.578,1.824c-1.018-1.09.09-2.409,1.15-2.981A3.3,3.3,0,0,0,8.373,7.061c-.725-1.6-1.347-1.64-.128-3.408a4.575,4.575,0,0,0,1.806,2.766c2.057,1.807,1.9,3.731-.521,5.067A16.689,16.689,0,0,0,5.853,14Zm.541-3.5C10.185,9.076,5.44,5.335,4.03,8.493,5.446,7.684,7.387,8.92,6.394,10.5Z"
	]
} as const
// Elements End

// DMG Bonus
export const faPhysicalDmgBonus = {
	prefix: 'faga',
	iconName: "physicalDmgBonus",
	icon: [
		14, 13.962,
		[],
		null,
		"M11.511,7.88,9.022,9.54v1.77l2.489-1.66L14,11.31V9.54Zm0,2.434-2.489,1.66v1.771l2.489-1.66L14,13.745V11.974ZM7.45,1.619l-.731.731a.228.228,0,0,0,0,.322l.837.837L.412,10.652a.458.458,0,0,0-.133.318A21.292,21.292,0,0,0,.04,13.922a21.435,21.435,0,0,0,2.952-.239.458.458,0,0,0,.318-.133l7.143-7.144c1.116,1.012.725,1.313,1.89.106a.228.228,0,0,0,0-.322L10.7,4.549l1.926-1.926c1.89.06,1.215.263,1.335-2.395A.228.228,0,0,0,13.734,0H11.542a.228.228,0,0,0-.228.219l.025,1.116L9.413,3.261,7.772,1.619A.228.228,0,0,0,7.45,1.619Z"
	]
} as const
// DMG Bonus End

// Base Stats
export const faAtk = {
	prefix: 'faga',
	iconName: "Atk",
	icon: [
		14, 13.977,
		[],
		null,
		"M7.78,1.621,9.423,3.264l1.928-1.927L11.326.219A.228.228,0,0,1,11.554,0h2.2a.228.228,0,0,1,.228.228c-.121,2.661.556,2.457-1.337,2.4L10.712,4.553,12.356,6.2a.228.228,0,0,1,0,.322c-1.167,1.208-.775.907-1.892-.106L3.313,13.564A.457.457,0,0,1,3,13.7a21.32,21.32,0,0,1-2.954.239,21.172,21.172,0,0,1,.238-2.954.451.451,0,0,1,.134-.318L7.564,3.513l-.838-.838a.229.229,0,0,1,0-.323l.732-.731A.228.228,0,0,1,7.78,1.621Z"
	]
} as const

export const faDef = {
	prefix: 'faga',
	iconName: "Def",
	icon: [
		12.883, 14,
		[],
		null,
		"M12.883.726a.291.291,0,0,0-.175-.268C12.3.286,10.944,0,6.442,0S.584.286.176.458A.291.291,0,0,0,0,.727v7.44a.868.868,0,0,0,.125.453c1.579,2.6,5.347,4.855,6.161,5.339a.292.292,0,0,0,.3,0c.789-.482,4.559-2.688,6.168-5.335a.868.868,0,0,0,.127-.455ZM6.441,11.968C6.5,11.981,2.882,9.951,1.617,7.6V1.565s0-.452,4.824-.452Z"
	]
} as const

export const faElementalMastery = {
	prefix: 'faga',
	iconName: "ele_mas",
	icon: [
		14, 13.113,
		[],
		null,
		"M8.076,7.71l-.017-.049A4.335,4.335,0,0,0,7.3,6.353a4.431,4.431,0,0,0-.325-.346A2.113,2.113,0,1,0,7,1.781a2.144,2.144,0,0,0-1.838,3.18,4.374,4.374,0,0,0-1.2-.168,4.42,4.42,0,0,0-.755.066l-.038.007C1.836-.682,10.7-2.114,10.962,3.9A3.985,3.985,0,0,1,8.076,7.71Zm3.662-2.137a3.949,3.949,0,0,0-.626-.235,4.473,4.473,0,0,1-1.105,1.7h.031A2.113,2.113,0,1,1,7.925,9.151,4.09,4.09,0,0,0,7.9,8.706,3.968,3.968,0,0,0,6.037,5.775l-.19-.11A3.963,3.963,0,1,0,6.492,12.2c.082-.068.16-.14.236-.214L6.7,11.949a4.367,4.367,0,0,1-.891-1.765A2.112,2.112,0,1,1,4.926,7.27q.1.051.189.111a2.111,2.111,0,0,1,.942,1.49,2.159,2.159,0,0,1,.018.28,3.963,3.963,0,1,0,5.663-3.578Z"
	]
} as const

// Max-HP stacked SVG (primary = base shape, secondary = flair)
export const faHpPrimary = {
	prefix: 'faga',
	iconName: "hp_primary",
	icon: [
		11.104, 14,
		[],
		null,
		"M2.052,7.654A.978.978,0,0,1,2.5,7.083c1.511-.85,3.586,2.117,6.544.548C10.971,13.714.151,13.878,2.052,7.654ZM5.552,14C2.177,14-1.2,11.579.416,6.74A18.543,18.543,0,0,1,5.121.213.748.748,0,0,1,5.552,0a.751.751,0,0,1,.431.212A18.543,18.543,0,0,1,10.688,6.74C12.3,11.579,8.927,14,5.552,14Zm.22-12.19a.639.639,0,0,0-.22-.075h0a.649.649,0,0,0-.221.075c-1.71,1.324-4.08,5.282-3.941,7.4a4.019,4.019,0,0,0,4.162,3.543h0A4.019,4.019,0,0,0,9.714,9.215C9.853,7.092,7.483,3.134,5.772,1.81Z"
	]
} as const

export const faHpSecondary = {
	prefix: 'faga',
	iconName: "hp_secondary",
	icon: [
		11.104, 14,
		[],
		null,
		"M6.534,8.03A12.566,12.566,0,0,1,8.107,6.521c.569-.413.94,1.11.94,1.11A3.731,3.731,0,0,1,6.534,8.03Z"
	]
} as const
// Max-HP stacked End

export const faMaxStamina = {
	prefix: 'faga',
	iconName: "MaxStamina",
	icon: [
		14, 10.365,
		[],
		null,
		"M13.924,6.541c-.152.207-1.292.3-1.292.3L9.77,6.948V8.564c0,.981-1.387,1.8-2.77,1.8s-2.77-.82-2.77-1.8V6.948L1.368,6.843s-1.14-.095-1.292-.3c-.239-.323.145-1.524.331-2.154.326-.865,1.284-3.21,1.885-3.119,1.115.17-.673,3.894.1,3.814A21.17,21.17,0,0,1,7,5a21.17,21.17,0,0,1,4.6.079c.777.08-1.011-3.644.1-3.814.6-.091,1.559,2.254,1.885,3.119C13.779,5.017,14.163,6.218,13.924,6.541ZM4.553,2.421a2.456,2.456,0,0,0,4.911,0A2.456,2.456,0,0,0,4.553,2.421Z"
	]
} as const

// Base Stats End

// Advanced Stats

// CD Reducation stacked SVG (primary = base shape, secondary = flair)
export const faCdReductionPrimary = {
	prefix: 'faga',
	iconName: "CdReduction_primary",
	icon: [
		14, 14,
		[],
		null,
		"M14,7A7,7,0,0,1,2.986,12.733L5.333,9.381A2.907,2.907,0,1,0,7,4.092V0a7,7,0,0,1,7,7"
	]
} as const

export const faCdReductionSecondary = {
	prefix: 'faga',
	iconName: "CdReduction_secondary",
	icon: [
		14, 14,
		[],
		null,
		"M5.333,9.381,2.986,12.733A7,7,0,0,1,.356,4.8l4.054.881a2.905,2.905,0,0,0,.923,3.7Z"
	]
} as const
// CD Reduction stacked end

export const faCritRate = {
	prefix: 'faga',
	iconName: "CritRate",
	icon: [
		14, 14,
		[],
		null,
		"M0,14,3.5,6.236,1.973,1.464,7.255,3.5,14,0,10.5,7.255l1.527,4.772L7.255,10.5,0,14"
	]
} as const

// Energy Recharge stacked SVG (primary = base shape, secondary = flair) 
export const faEnergyRechargePrimary = {
	prefix: 'faga',
	iconName: "EnergyRecharge_primary",
	icon: [
		14, 13.282,
		[],
		null,
		"M14,6.641A6.642,6.642,0,0,1,.928,8.3h0L0,8.737.961,4.8l.012.012L2.392,6.3l1.37,1.433-1.23.143A4.981,4.981,0,1,0,7.359,1.66V0A6.641,6.641,0,0,1,14,6.641Z"
	]
} as const

export const faEnergyRechargeSecondary = {
	prefix: 'faga',
	iconName: "EnergyRecharge_secondary",
	icon: [
		14, 13.282,
		[],
		null,
		"M2.392,6.3.973,4.813A6.643,6.643,0,0,1,7.359,0V1.66A4.98,4.98,0,0,0,2.392,6.3Z"
	]
} as const
// Energy Recharge stacked end

export const faHealingBonus = {
	prefix: 'faga',
	iconName: "HealingBonus",
	icon: [
		14, 14,
		[],
		null,
		"M14,4.765v4.47a.589.589,0,0,1-.588.589H9.824v3.588A.589.589,0,0,1,9.235,14H4.765a.589.589,0,0,1-.589-.588V9.824H.588A.589.589,0,0,1,0,9.235V4.765a.589.589,0,0,1,.588-.589H4.176V.588A.589.589,0,0,1,4.765,0h4.47a.589.589,0,0,1,.589.588V4.176h3.588A.589.589,0,0,1,14,4.765Z"
	]
} as const

export const faShieldStrength = {
	prefix: 'faga',
	iconName: "ShieldStrength",
	icon: [
		12.883, 14,
		[],
		null,
		"M12.883.726a.291.291,0,0,0-.175-.268C12.3.286,10.944,0,6.442,0S.584.286.176.458A.291.291,0,0,0,0,.727v7.44a.868.868,0,0,0,.125.453c1.579,2.6,5.347,4.855,6.161,5.339a.292.292,0,0,0,.3,0c.789-.482,4.559-2.688,6.168-5.335a.868.868,0,0,0,.127-.455ZM5.136,10.773,6.182,7l-4-1,5.61-4.762L6.747,5.01l4,1Z"
	]
} as const
// Advanced Stats End

// Artifacts
export const faCirclet = {
	prefix: 'faga',
	iconName: "Circlet",
	icon: [
		14, 11.588,
		[],
		null,
		"M12.793,3.842l.269.269L10.5,5.93,7.269,2.158l.809-.809L7,0,5.922,1.349l.809.809L3.5,5.93.938,4.111l.269-.269L0,2.965,2.958,9.972,7,11.588l4.042-1.616L14,2.965ZM8.732,7.864l-.892.149a.673.673,0,0,0-.543.5l-.25,1a.048.048,0,0,1-.094,0l-.25-1a.673.673,0,0,0-.543-.5l-.892-.149a.049.049,0,0,1,0-.1l.892-.149a.673.673,0,0,0,.543-.5l.25-1a.048.048,0,0,1,.094,0l.25,1a.673.673,0,0,0,.543.5l.892.149A.049.049,0,0,1,8.732,7.864Z"
	]
} as const

export const faFlower = {
	prefix: 'faga',
	iconName: "Flower",
	icon: [
		14, 13.326,
		[],
		null,
		"M11.279,4.705a2.554,2.554,0,0,0-1.6.9C11.215,3.854,12.708.454,9.711.3c-.015-.115-.2-.387-.4-.276A5.942,5.942,0,0,0,7.2,4.742C6.705,2.18,4.078.459,3.016.769c-.207.324-.056.607-.261.793-.18.163-.58-.016-.619.249-.324,1.729.945,3.632,2.758,4.532C3.113,6.057.165,6.349,0,8.491,0,9.43,1.269,9.868,3.191,9.868A3.541,3.541,0,0,0,6.319,8.4c-2.541,2.727-.544,3.278,2.192,1.78,1.073-.621.8-1.4.027-2.295,1.395.853,3.755-.174,3.877-1.72C12.414,5.533,12.142,4.718,11.279,4.705ZM7.521,6.213a.5.5,0,0,1-.441.5l-.1.637L6.9,6.694A.5.5,0,0,1,6.538,6.1l-.467-.567.557.377a.5.5,0,0,1,.706-.086l.459-.381-.356.492A.5.5,0,0,1,7.521,6.213ZM14,8.089c-.519.249-.77,1.7-1.586,2.337a3.966,3.966,0,0,1-2.678.5,3.463,3.463,0,0,1-1.881,2.393.041.041,0,0,1-.05-.064,4.294,4.294,0,0,0,1-3.174A1.125,1.125,0,0,0,8.956,8.3c.344.065.828,1.348.876,2.125,0,0,1.857-1.178,2.355-1.37A6.666,6.666,0,0,0,9.877,10.3a5.933,5.933,0,0,1,1.269-1.5C11.757,8.271,13.548,8.252,14,8.089Z"
	]
} as const

export const faGoblet = {
	prefix: 'faga',
	iconName: "Goblet",
	icon: [
		14, 13.864,
		[],
		null,
		"M9.546,8.637c4.121-2.3,4.121-3.555,4.12-6.894H.428c0,3.339,0,4.59,4.12,6.894,0,1.75,1.739,1.28,1.739,2.187.076.765-.192,1.207-.567,1.275-1.21.167-3.368.939-3.383,1.765h9.42c-.015-.826-2.173-1.6-3.383-1.765-.374-.068-.644-.509-.567-1.275C7.807,9.917,9.546,10.387,9.546,8.637ZM7.461,5.723,7.113,7.116a.066.066,0,0,1-.066.052.066.066,0,0,1-.066-.052L6.633,5.723a.941.941,0,0,0-.757-.7L4.631,4.817a.068.068,0,0,1,0-.135l1.245-.207a.939.939,0,0,0,.757-.7l.348-1.393a.066.066,0,0,1,.066-.051.067.067,0,0,1,.066.051l.348,1.393a.939.939,0,0,0,.757.7l1.245.207a.068.068,0,0,1,0,.135l-1.245.207A.941.941,0,0,0,7.461,5.723Zm5.881-4.408H.658A.657.657,0,0,1,0,.658H0A.657.657,0,0,1,.658,0H13.342A.657.657,0,0,1,14,.658h0A.657.657,0,0,1,13.342,1.315Z"
	]
} as const

export const faPlume = {
	prefix: 'faga',
	iconName: "Plume",
	icon: [
		12.933, 14,
		[],
		null,
		"M11.809,0a4.52,4.52,0,0,0-1,.186,4.469,4.469,0,0,0-1.479.6c-.236.14-.241.324-.312.274a.717.717,0,0,0-.467-.033C5.117,3.737,5.04,3.893,3.285,6.494,3.171,6.54,3,6.384,3,6.384c-.059.546-.215.546-.526,1.168A2.75,2.75,0,0,0,2.1,9.588a2.49,2.49,0,0,1-.723-.245l.467.39a2.681,2.681,0,0,1-.934.078l.623.467s-.39.389-.546.389l.519.074A18.034,18.034,0,0,0,0,13.948.04.04,0,0,0,.045,14l.593-.3a.038.038,0,0,0,.02-.025,5.139,5.139,0,0,1,1.722-2.7l.479.549a1.881,1.881,0,0,1-.155-.779l.856.156c-.389-.39-.35-.56-.35-.56a4.067,4.067,0,0,0,1.6-.034,8.175,8.175,0,0,0,1.705-.865c.084-.04-.146-.082-.066-.124s.329-.095.413-.145A20.31,20.31,0,0,0,9.415,7.147a11.77,11.77,0,0,0,2.367-2.7c.043-.074-.36-.2-.526-.231.177.021.616.121.654.048a6.256,6.256,0,0,0,.86-2.34C12.826,1.245,13.449-.079,11.809,0ZM2.548,9.577C4.5,5.372,10.1,1.946,10.1,1.946,11.87.561,6.141,4.384,2.548,9.655Z"
	]
} as const

export const faSands = {
	prefix: 'faga',
	iconName: "Sands",
	icon: [
		9.822, 14,
		[],
		null,
		"M9.606,12.708H8.788v-.944c0-3.536-3.274-3.709-3.274-4.915V6.778a.855.855,0,0,1,.392-.72c.868-.56,2.773-1.311,2.877-3.895a.216.216,0,0,0-.215-.225H1.254a.217.217,0,0,0-.216.225c.1,2.584,2.009,3.335,2.877,3.9a.856.856,0,0,1,.393.72v.071c0,1.206-3.274,1.379-3.274,4.915v.944H.215A.215.215,0,0,0,0,12.923v.862A.215.215,0,0,0,.215,14H9.606a.216.216,0,0,0,.216-.215v-.862A.216.216,0,0,0,9.606,12.708Zm-4.695,0h-3.1c0-2.757,2.757-2.154,2.757-3.274V5.988S2.929,5.04,2.929,4.351H6.892c0,.689-1.637,1.637-1.637,1.637V9.434c0,1.12,2.757.517,2.757,3.274ZM9.822.215v.862a.216.216,0,0,1-.216.215H.215A.215.215,0,0,1,0,1.077V.215A.215.215,0,0,1,.215,0H9.606A.216.216,0,0,1,9.822.215Z"
	]
} as const
// Artifacts End